import { api } from './index';

const CampaignRequestService = {
    getAll: async(params) => {
        return await api.get('campaign-request',params);
    },
    getAllExport: async(params) => {
        return await api.get('company-request-export',params);
    },
    getCapaign: async(id) => {
        return await api.get('campaign-request/'+id);
    },
    saveCampaign: async(id,form) => {
        return await api.put('campaign-request/'+id,form);
    },
    getInfoResale: async() => {
        return await api.get('company-request/info-form');
    },
    getCampaignCompanies: async(id) => {
        return await api.get('campaign-request/companies/'+id);
    },
    updateResaleContacts: async(id,form) => {
        return await api.put('company-request/contacts/'+id,form);
    },
    getResaleBUs: async(id) => {
        return await api.get('company-request/bus/'+id);
    },
    updateResaleBUs: async(id,form) => {
        return await api.put('company-request/bus/'+id,form);
    },
    getResaleAttendance: async(id,params) => {
        return await api.get('company-request/attendance/'+id,params);
    },
    getResaleBrands: async(id,params) => {
        return await api.get('company-request/brands/'+id,params);
    },
    getResaleLeadHistory: async(id,params) => {
        return await api.get('company-request/lead-history/'+id,params);
    },
    
};

export default CampaignRequestService;